<template>
    <div>
        <validation-observer ref="forms" v-slot="{handleSubmit}">
            <form class="form-group"
                  @submit.prevent="handleSubmit(submitNoticia)">

                <div class="grid-1 form-1">
                    <validation-provider
                        name="Título"
                        vid="titulo"
                        rules="required"
                        v-slot="{errors}"
                        tag="div"
                        class="input-std"
                    >
                        <label>
                            Título
                            <input
                                type="text"
                                id="titulo"
                                name="titulo"
                                v-model="noticia.titulo"
                                placeholder="Título da Notícia"
                            >
                        </label>
                        <p class="errors">{{errors[0]}}</p>
                    </validation-provider>
                    <validation-provider
                        name="Subtítulo"
                        vid="subtitulo"
                        rules=""
                        v-slot="{errors}"
                        tag="div"
                    >
                        <label>
                            Subtítulo
                            <input
                                type="text"
                                id="subtitulo"
                                name="subtitulo"
                                v-model="noticia.subtitulo"
                                placeholder="Subtítulo da Notícia"
                            >
                        </label>
                        <p class="errors">{{errors[0]}}</p>
                    </validation-provider>
                </div>

                <div class="grid-1 form-2">
                    <validation-provider
                        name="Categoria"
                        vid="categoria"
                        rules="required"
                        v-slot="{errors}"
                        tag="div"
                    >
                        <label>
                            Categoria
                            <select name="categoria" id="categoria"
                                    v-model="noticia.categoria"
                                    :class="{'text-base-gray':
                                        noticia.categoria === '' }">
                                <option value=""  disabled>
                                    Categoria</option>
                                <option value="1" class="text-black">
                                    UGT-Notícias
                                </option>
                                <option value="4" class="text-black">
                                    Palavra do Presidente
                                </option>
                                <option value="5" class="text-black">
                                    Comentário do Diretor (Artigo)
                                </option>
                            </select>
                        </label>
                        <p class="errors">{{errors[0]}}</p>
                    </validation-provider>
                    <validation-provider
                        name="Data da Notícia"
                        vid="data-noticia"
                        rules="required"
                        v-slot="{errors}"
                        tag="div"
                    >
                        <label>
                            Data da Notícia
                            <flat-pickr
                                v-model="noticia.data_noticia"
                                :config="config"
                                name="data-noticia"
                                id="data-noticia"
                                placeholder="Selecione a data da Notícia"
                            >
                            </flat-pickr>
                        </label>
                        <p class="errors">{{errors[0]}}</p>
                    </validation-provider>

                    <div class="flex justify-around sm:col-span-2">
                        <div>
                            <p class="mb-4 text-black">Disponível</p>
                            <div class="form-checkbox">
                                <label>
                                    <span class="ml-4 text-dark-gray">
                                          {{noticia.ativo ? 'Sim' : 'Não'}}
                                    </span>
                                    <input type="checkbox" id="disponivel"
                                           name="disponivel"
                                           v-model="noticia.ativo">
                                    <span class="slider"></span>
                                </label>
                            </div>
                        </div>
                        <div>
                            <p class="mb-4 text-black">Manchete</p>
                            <div class="form-checkbox">
                                <label>
                                    <span class="ml-4 text-dark-gray">
                                         {{noticia.manchete ? 'Sim' : 'Não'}}
                                    </span>
                                    <input type="checkbox" id="manchete"
                                           name="manchete"
                                           v-model="noticia.manchete" >
                                    <span class="slider"></span>

                                </label>
                            </div>
                        </div>
                    </div>
                    <validation-provider
                        v-if="noticia.manchete"
                        name="Posição no Carrosel"
                        vid="posicao"
                        rules="required"
                        v-slot="{errors}"
                        tag="div"
                    >
                        <label>
                            Posição no carrosel
                            <select
                                name="posicao"
                                id="posicao"
                                v-model="noticia.posicao"
                                :class="{'text-base-gray':
                                    noticia.posicao === null }"
                            >
                                <option :value="null" disabled>
                                    Posição no Carrosel
                                </option>
                                <option value="1" class="text-black">
                                    Primeira Notícia
                                </option>
                                <option value="2"  class="text-black">
                                    Segunda Notícia
                                </option>
                                <option value="3"  class="text-black">
                                    Terceira Notícia
                                </option>
                                <option value="4"  class="text-black">
                                    Quarta Notícia
                                </option>
                            </select>
                        </label>
                        <p class="errors">{{errors[0]}}</p>
                    </validation-provider>
                </div>
                <div class="my-4">
                    <validation-provider
                        name="Imagem da Notícia"
                        vid="imagem-noticia"
                        rules="required"
                        v-slot="{errors}"
                        tag="div"
                    >
                        <label> Foto da Notícia</label>
                        <input-file
                            :title="'Foto da Notícia'"
                            :name="'imagem'"
                            id="imagem-noticia"
                            :value="imagens"
                            url="imagens"
                            @changeFile="imagens = $event.files"
                        ></input-file>
                    </validation-provider>
                </div>
                <div class="my-4 text-black">
                    <validation-provider
                        name="Notícia"
                        vid="noticia"
                        rules="required"
                        v-slot="{errors}"
                        tag="div"
                    >
                        <label> Noticia</label>
                        <vue-editor
                            id="noticia"
                            name="noticia"
                            v-model="noticia.noticia"
                            placeholder="Insira a notícia aqui..."
                        ></vue-editor>
                        <p class="errors">{{errors[0]}}</p>
                    </validation-provider>
                </div>
                <div class="flex justify-end">
                    <button class="btn btn-primary">
                        {{ (!noticia.id) ? 'Salvar Notícia' : 'Atualizar Notícia' }}
                    </button>
                </div>
            </form>
        </validation-observer>
    </div>
</template>

<script>
import { VueEditor } from "vue2-editor";
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import 'flatpickr/dist/themes/airbnb.css';

const Brasil = require('flatpickr/dist/l10n/pt.js').default.pt;

export default {
    name: "form-noticia",
    components: {
        VueEditor,
        flatPickr
    },
    data() {
        return {
            noticiaId: '',
            imagens: [],
            noticia: {
                id: null,
                titulo: '',
                subtitulo: '',
                tituloslug: '',
                categoria: '',
                manchete: false,
                data_noticia: null,
                noticia: '',
                posicao: null,
                views: 0,
                ativo: false,
            },
            config: {
                wrap: true,
                altInput: true,
                altFormat: 'd/m/Y',
                dateFormat: 'Y-m-d',
                enableTime: false,
                allowInput: true,
                locale: Brasil,
            },
        }
    },
    methods: {
        submitNoticia() {
            this.noticia.manchete
                ? this.noticia.manchete = 1
                : this.noticia.manchete = 0;

            this.noticia.ativo
                ? this.noticia.ativo = 1
                : this.noticia.ativo = 0;

            this.noticia.tituloslug =
                this.noticia.titulo.toLowerCase().replace(" ", "-");

            this.axios.post('/noticias', this.noticia)
                .then(response => {
                    if (response.status === 200) {
                        const novaImagens = {
                            noticia_id: response.data.noticia.id,
                            imagem: this.imagens
                        }
                        this.axios.post('/imagens', novaImagens)
                            .then(response => {
                                if (response.status === 200) {
                                    this.$swal({
                                        title: 'Sucesso',
                                        text: (this.noticia.id) ? 'A notícia foi atualizada com sucesso' : 'A notícia foi criada com sucesso',
                                        icon: 'success',
                                    })
                                    this.$router.push('/sistema/noticias/lista-noticias');
                                }
                            })
                    }
                }).catch(error => {
                this.$swal({
                    title: 'Algo de errado ocorreu',
                    text: error.response.data.message,
                    icon: 'error',
                });
            });
        },
        getNoticia() {
            this.axios.get(`/noticias/${this.noticiaId}`)
            .then(response => {
                const { noticia } = response.data;
                this.noticia.ativo = noticia.ativo;
                this.noticia.categoria = noticia.categoria;
                this.noticia.id =  noticia.id;
                this.noticia.manchete = noticia.manchete;
                this.noticia.noticia = noticia.noticia;
                this.noticia.posicao = noticia.posicao;
                this.noticia.subtitulo = noticia.subtitulo;
                this.noticia.titulo = noticia.titulo;
                this.noticia.tituloslug = noticia.tituloslug;
                const date = noticia.data_noticia.split('/')
                this.noticia.data_noticia = `${date[2]}-${date[1]}-${date[0]}`

                this.imagens = noticia.imagens.map(imagem => {
                    return {
                        id: imagem.id,
                        imagem: imagem.imagem
                    }
                });
            })
        }
    },
    async created() {
        const { id } = this.$route.params;
        this.noticiaId = id;
        if (id) {
           await this.getNoticia();
        }
    }
}
</script>
<style lang="scss" scoped>
.form-1{
    @media(min-width: 640px) {
        @apply grid-cols-2;
    }
}
.form-2{
    @media(min-width: 640px) {
        @apply grid-cols-4;
    }
}
</style>
